import { render, staticRenderFns } from "./ImageWithText.vue?vue&type=template&id=1ad9aa43&scoped=true&"
import script from "./ImageWithText.vue?vue&type=script&lang=ts&"
export * from "./ImageWithText.vue?vue&type=script&lang=ts&"
import style0 from "./ImageWithText.vue?vue&type=style&index=0&id=1ad9aa43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad9aa43",
  null
  
)

export default component.exports